import { SearchSuggestions } from './search-suggestions';

export { SearchSuggestions };
